import { CommonLabel } from './Common';

export const entityTypeLabel = (object, isEntityObject) => {
  let color;
  let backgroundColor;
  let text;

  let entityTypeColor;
  let entityTypeName;

  if (isEntityObject) {
    entityTypeColor = object.entity_type.color;
    entityTypeName = object.entity_type.name;
  } else {
    entityTypeColor = object.entity_type_color;
    entityTypeName = object.entity_type;
  }

  switch (true) {
    case entityTypeColor === 'blue':
      color = '#1177a4';
      backgroundColor = '#d6f4f9';
      text = `${entityTypeName}`;
      break;

    case entityTypeColor === 'purple':
      color = '#ffffff';
      backgroundColor = '#96034e';
      text = `${entityTypeName}`;
      break;

    case entityTypeColor === 'green':
      color = '#118d57';
      backgroundColor = '#dbf6e5';
      text = `${entityTypeName}`;
      break;

    case entityTypeColor === 'yellow':
      color = '#b76e00';
      backgroundColor = '#fff1d6';
      text = `${entityTypeName}`;
      break;

    case entityTypeColor === 'red':
      color = '#b71d18';
      backgroundColor = '#ffe4de';
      text = `${entityTypeName}`;
      break;

    case entityTypeColor === 'orange':
      color = '#ffffff';
      backgroundColor = '#ff5630';
      text = `${entityTypeName}`;
      break;

    case entityTypeColor === 'red_dark':
      color = '#ffffff';
      backgroundColor = '#930000';
      text = `${entityTypeName}`;
      break;

    case entityTypeColor === 'red_light':
      color = '#ffffff';
      backgroundColor = '#e21515';
      text = `${entityTypeName}`;
      break;

    case entityTypeColor === 'brown':
      color = '#ffffff';
      backgroundColor = '#7a410b';
      text = `${entityTypeName}`;
      break;

    default:
      color = '#637381';
      backgroundColor = '#edeff1';
      text = `${entityTypeName}`;
      break;
  }

  return <CommonLabel textColor={color} bgColor={backgroundColor} text={text} />;
};
